import React from 'react';
import { Hero } from './components/sections/Hero';
import { Testimonials } from './components/sections/Testimonials';
import { PainPoints } from './components/sections/PainPoints';
import { ForWhom } from './components/sections/ForWhom';
import { SystemOverview } from './components/sections/SystemOverview';
import { Tomos } from './components/sections/Tomos';
import { Bonuses } from './components/sections/Bonuses';
import { Comparison } from './components/sections/Comparison';
import { ScarcityCountdown } from './components/sections/ScarcityCountdown';
import { Pricing } from './components/sections/Pricing';
import { PackUpsell } from './components/sections/PackUpsell';
import { Guarantee } from './components/sections/Guarantee';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { SocialProofPopup } from './components/ui/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-brown selection:bg-terracotta/30" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <SocialProofPopup data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Testimonials data-id="element-5" />
        <PainPoints data-id="element-6" />
        <ForWhom data-id="element-7" />
        <SystemOverview data-id="element-8" />
        <Tomos data-id="element-9" />
        <Bonuses data-id="element-10" />
        <Comparison data-id="element-11" />
        <ScarcityCountdown data-id="element-12" />
        <Pricing data-id="element-13" />
        <PackUpsell data-id="element-14" />
        <Guarantee data-id="element-15" />
        <FAQ data-id="element-16" />
        <FinalCTA data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
    </div>;
}